import common from './common'

export default {
  ...common.button,
  color: `background`,
  bg: `alpha`,
  borderColor: `alpha`,
  ':hover': {
    color: `background`,
    bg: `omegaDark`,
    borderColor: `omegaDark`
  }
}
